import React, { useState, useEffect } from "react";
import "./Card.css";

function Card(props) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [image, setImage] = useState(null);

    useEffect(() => {
      setImage(props.image);
    }, []);

  const handleCardClick = () => {
    if (props.onClick) {
      props.onClick();
    }
    setIsFlipped(true);
  };

  return (
    <div
        className={"card" + (props.higher ? " card-higher" : "")}
        onClick={props.disableClick ? null : handleCardClick}
    >
      <div className={"card-inner" + (isFlipped ? " flipped" : "")}>
        <div className="card-front"/>
        <div className="card-back">
            <img src={image} alt="card" className="card-image"/>
        </div>
      </div>
    </div>
  );
}

export default Card;